export default `
Geoff Pleiss is an assistant professor in the Department of Statistics at the University of British Columbia,
as well as a Canada CIFAR AI Chair affiliated with the Vector Institute.
He earned a Ph.D. in Computer Science from Cornell University under the supervision of Kilian Weinberger.
Geoff specializes in uncertainty quantification in machine learning,
especially within the contexts of Bayesian optimization, spatiotemporal modelling, and scientific discovery.
His work has been recognized with the Blackwell-Rosenbluth Award and an AISTATS Best Student Paper Award.
Additionally, Geoff has co-founded several widely-used open source software projects, including the GPyTorch, LinearOperator, and CoLA libraries.
`
